import { __decorate, __metadata } from "tslib";
import { CalendarHeatmap } from "vue-calendar-heatmap";
import { Component, Mixins, Prop } from "vue-property-decorator";
import BaseMixer from "../../BaseMixer";
import { ProjectModule } from "@/store/modules/project.module";
import { interpret } from "xstate";
import VueCarousel from "@/components/vueCarousel.vue";
import simplebar from "simplebar-vue";
import Loader from "@/components/widgets/loader.vue";
import VueCarouselProjects from "@/components/vueCarouselProjects.vue";
import { RlCarouselSlide } from "vue-renderless-carousel";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import projectAnalyticsDetailsMachine from "@/router/views/analytics/machines/projectAnalyticsDetailsMachine";
let ProjectAnalyticsDetailsComponent = /** @class */ (() => {
    let ProjectAnalyticsDetailsComponent = class ProjectAnalyticsDetailsComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.machine = projectAnalyticsDetailsMachine.withContext({
                selectedProjectId: "",
                operationIndex: 0,
                operationType: "",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        get projectDetail() {
            return ProjectModule.projectAnalyticsDetail;
        }
        get projectworkeffort() {
            return ProjectModule.projectAnalyticsDetail.projectWorkEffortTotal;
        }
        get projectTotalTimeSpent() {
            let value = this.projectworkeffort / 60;
            let hours = Math.floor(value / 60);
            let minutes = value % 60;
            let formattedMinutes = minutes.toFixed(0);
            return hours + " Hrs " + formattedMinutes + " m";
        }
        get projectOwner() {
            if (this.projectDetail != null && this.projectDetail.projectAnalyticsMembersDetail.teamMembers != null) {
                return ProjectModule.projectAnalyticsDetail.projectAnalyticsMembersDetail.teamMembers.find((x) => x.employeeId == ProjectModule.projectAnalyticsDetail.projectOwnerId);
            }
            return null;
        }
        get projectDailyHours() {
            return ProjectModule.projectDailyHoursCalculations;
        }
        get projectDailyHoursMaxDate() {
            return new Date().toISOString().slice(0, 10);
        }
        get selectedProjectIndex() {
            return this.projectsCarousel.findIndex((x) => x.parentProjectId == this.state.context.selectedProjectId);
        }
        get operation() {
            const operationType = this.state.context.operationType;
            const capitalizedWords = operationType.replace(/([A-Z])/g, " $1").trim();
            return capitalizedWords.charAt(0).toUpperCase() + capitalizedWords.slice(1);
        }
        showModal(projectid) {
            this.state.context.selectedProjectId = projectid;
            this.$bvModal.show("project-details-modal");
            this.getProjectAnalyticsDetails();
        }
        selectProject(projectid) {
            this.state.context.selectedProjectId = projectid;
            this.getProjectAnalyticsDetails();
        }
        getProjectAnalyticsDetails() {
            this.send({
                type: "GETTING_PROJECT_ANALYTICS_DETAILS",
            });
        }
        CloseModal() {
            this.$bvModal.hide("project-details-modal");
            this.send({ type: "MAKE_MODAL_DORMANT" });
        }
        onTabChange(bTabIndex) {
            this.state.context.operationIndex = bTabIndex;
            this.send({ type: "ON_TAB_CHANGE" });
        }
        GoToProjectOverView(projectId) {
            this.$router.push({ name: "ProjectOverview", params: { projectId: projectId } });
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ProjectAnalyticsDetailsComponent.prototype, "filterSelected", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ProjectAnalyticsDetailsComponent.prototype, "projectsCarousel", void 0);
    ProjectAnalyticsDetailsComponent = __decorate([
        Component({
            name: "ProjectAnalyticsDetailsComponent",
            components: {
                CalendarHeatmap,
                VueCarousel,
                simplebar,
                Loader,
                VueCarouselProjects,
                RlCarouselSlide,
                SectionLoader,
            },
        })
    ], ProjectAnalyticsDetailsComponent);
    return ProjectAnalyticsDetailsComponent;
})();
export default ProjectAnalyticsDetailsComponent;
